<template>
  <v-row wrap >
    <v-col>
      <v-list
        v-if="visitEmployees"
      >
        <template v-for="(employee) in visitEmployees">
          <v-list
            :key="employee._id"
            :visitEmployees="visitEmployees"
            :v-if="
              $store.state.auth.user.roles[0] !=
              $store.state.constants.roles.SECURITY
            "
          >
            <v-list-item-content :key="employee._id">
              <v-list-item slot="activator" >
                <v-col class="col-1">
                  <v-icon color="primary">people</v-icon>
                </v-col>
                <v-col two-line>
                  <v-list-item-title>
                    {{ employee.firstName }}
                    &nbsp;
                    {{ employee.lastName }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ `${employee.identifier.type.toUpperCase()} ` }}
                    {{ employee.identifier.number }}
                  </v-list-item-subtitle>
                </v-col>
              </v-list-item>
            </v-list-item-content>
          </v-list>
          <v-divider
            :key="'_' + employee._id"
          ></v-divider>
        </template>
      </v-list>
    </v-col>
  </v-row>
</template>

<script>
"use strict";

export default {
  name: "editRateEmployeesDetails",
  props: {
    visitEmployees: { type: Array },
  }
};
</script>
